import { Box, Stack, Typography } from "@mui/material";
import AutomationSetupReady from "./AutomationSetupReady";
import AutomationSummaryCard from "./AutomationSummaryCard";
import AutomationSetupOpenButton from "./AutomationSetupOpenButton";
import { approvalError } from "./automationSetupApprovalCopy";

export default function AutomationSetupContent({
  active,
  setup,
  days,
  setDays,
  activate,
  title,
  onOpen,
}) {
  const hasSummary = setup.semanticPlan || setup.cards?.length;
  const openButton = <AutomationSetupOpenButton onOpen={onOpen} />;
  return (
    <Stack spacing={1.25} sx={{ p: 1.5 }}>
      {active && hasSummary ? (
        <Stack direction="row" alignItems="center" spacing={1.5}>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <AutomationSummaryCard title={title} setup={setup} />
          </Box>
          {openButton}
        </Stack>
      ) : !active && onOpen ? (
        <Stack direction="row" justifyContent="flex-end">
          {openButton}
        </Stack>
      ) : null}
      {!active && setup.loading ? (
        <Typography>Loading approval details…</Typography>
      ) : null}
      {!active && setup.error ? (
        <Typography color="error">
          Couldn’t load the approval details. Refresh and try again.
        </Typography>
      ) : null}
      {!active && !setup.loading && !setup.error ? (
        <AutomationSetupReady {...{ setup, days, setDays, activate, title }} />
      ) : null}
      {setup.mutation.error ? (
        <Typography color="error">
          {approvalError(setup.mutation.error)}
        </Typography>
      ) : null}
    </Stack>
  );
}